const _identityVerify = `^[0-9a-zA-Z]{1,50}$`;
const _orgCodeVerify = `^[0-9a-zA-Z_-]{9,10}$`;
const _businessLicenseNoVerify = `^[0-9a-zA-Z]{18}$`;
const _businessLicenseNumberVerify = `(^[0-9a-zA-Z]{15}$)|^[0-9a-zA-Z]{18}$`;
const _taxRegistNoVerify = `^[0-9a-zA-Z]{18}$`;
const _registerCapitalVerify = /^(\d+|\d+\.\d{1,6})$/;

// 身份证
export const identityVerify = new RegExp(_identityVerify.replace(/(\r\n)|(\n)/g, ''));

// 组织机构代码
export const orgCodeVerify = new RegExp(_orgCodeVerify.replace(/(\r\n)|(\n)/g, ''));

// 营业执照注册号/社会信用代码
export const businessLicenseNoVerify = new RegExp(_businessLicenseNoVerify.replace(/(\r\n)|(\n)/g, ''));
export const businessLicenseNumberVerify= new RegExp(_businessLicenseNumberVerify.replace(/(\r\n)|(\n)/g, ''));

// 税务登记号
export const taxRegistNoVerify = new RegExp(_taxRegistNoVerify.replace(/(\r\n)|(\n)/g, ''));

// 注册资金
// export const registerCapitalVerify = new RegExp(_registerCapitalVerify.replace(/(\r\n)|(\n)/g, ''));
export const registerCapitalVerify = new RegExp(_registerCapitalVerify);

const registerDateVerify = (rule, value, callback) => {
    const now = new Date();
    const dateValue = new Date(value);
    if (dateValue > now) {
        callback(new Error('成立日期不能超过当日'));
    } else {
        callback();
    }
};

export const FIELDS_EXTRA_RULES = {
    idCard: [
        { pattern: identityVerify, message: '身份证格式错误', trigger: ['blur', 'change'] }
    ],
    businessLicenseNo: [
        { pattern: businessLicenseNumberVerify, message: '营业执照注册号格式错误', trigger: ['blur', 'change'] }
    ],
    taxRegistNo: [
        { pattern: taxRegistNoVerify, message: '税务登记号格式错误', trigger: ['blur', 'change'] }
    ],
    orgCode: [
        { pattern: orgCodeVerify, message: '组织机构代码格式错误', trigger: ['blur', 'change'] }
    ],
    societyCreditCode: [
        { pattern: businessLicenseNoVerify, message: '社会信用代码格式错误', trigger: ['blur', 'change'] }
    ],
    registerCapital: [
        { pattern: registerCapitalVerify, message: '注册资金格式错误', trigger: ['blur', 'change'] }
    ],
    registerDate: [
        { validator: registerDateVerify, trigger: ['blur', 'change'] }
    ],
    supplierSimpleName: [
        { max: 50, message: '文本限制50个字以内', trigger: ['blur', 'change'] }
    ]
};